/**
 * Check if in an array of images all the values are "truthy".
 */
const imagesAreReady = (images: Array<string | null | undefined>) => images.every((image) => Boolean(image));

export default imagesAreReady;
